import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';

import { Checkbox, InputField, SelectField } from 'Common/SemanticWrapper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';
import { convertEnumToDropdownArray } from 'Common/Constants/Enumeration/ConvertEnumToDropdownArray';
import { LanguageEnum } from 'Common/Constants/Enumeration/LanguageEnum';

const languages = convertEnumToDropdownArray(LanguageEnum);

export const LanguageSsnForm = ({
  className,
  handleSSNChange,
  handleNoSSNChange,
}) => {
  return (
    <Grid className={className}>
      <Grid.Row style={{ height: '7rem' }}>
        <Grid.Column width={5}>
          <Field
            style={{ width: '60%' }}
            component={InputField}
            label={'SSN (Last 4 only)'}
            maxLength={4}
            name={Fields.SSN}
            mode={InputMode.Integer}
            onChange={handleSSNChange}
          />
        </Grid.Column>
        <Grid.Column width={5}>
          <Field
            component={SelectField}
            label={'Language'}
            name={Fields.LanguageId}
            options={languages}
            style={{ zIndex: 100 }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={5} style={{ paddingLeft: '1.2rem' }}>
          <Field
            component={Checkbox}
            label={'No SSN'}
            name={Fields.NoSSN}
            options={languages}
            onChange={handleNoSSNChange}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hoh/HOHLanguageSSNForm.js